import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import ScrollToTop from './components/common/ScrollToTop';
import ErrorBoundary from './components/common/ErrorBoundary';
import LoadingSpinner from './components/common/LoadingSpinner';

const Homepage = lazy(() => import('./pages/Homepage'));
const WarmtepompenPage = lazy(() => import('./pages/WarmtepompenPage'));
const OverOnsPage = lazy(() => import('./pages/OverOnsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const DealerWordenPage = lazy(() => import('./pages/DealerWordenPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <ErrorBoundary>
          <Suspense
            fallback={
              <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" text="Laden..." />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Homepage />} />
              <Route path="/warmtepompen" element={<WarmtepompenPage />} />
              <Route path="/products" element={<Navigate to="/warmtepompen" replace />} />
              <Route path="/over-ons" element={<OverOnsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/dealer-worden" element={<DealerWordenPage />} />
              <Route path="/catalogus" element={<Navigate to="/warmtepompen" replace />} />
              <Route path="/shop" element={<Navigate to="/warmtepompen" replace />} />
              <Route
                path="/login"
                element={<Navigate to="/" replace />}
              />
              <Route path="/dashboard" element={<Navigate to="/" replace />} />
              <Route path="/orders" element={<Navigate to="/" replace />} />
              <Route path="/clients" element={<Navigate to="/" replace />} />
              <Route path="/calculator" element={<Navigate to="/" replace />} />
              <Route path="/support" element={<Navigate to="/contact" replace />} />
              <Route path="/downloads" element={<Navigate to="/" replace />} />
              <Route path="/settings" element={<Navigate to="/" replace />} />
              <Route path="/cart" element={<Navigate to="/" replace />} />
              <Route path="/admin/*" element={<Navigate to="/" replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
      </div>
    </Router>
  );
}

export default App;
